import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Elements
import SolutionSidebar from '../elements/services/solution-sidebar';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_31.jpg';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionWellCleaningMaintenance extends Component {

    render(){
        return (
            <>
                <Header1 />
                
                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Well Cleaning & Maintenance</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Well Cleaning & Maintenance</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2 bg-fix bg-white">
                            <div className="container about-video">
                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={3} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Well Cleaning & Maintenance</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>We provide advanced chemical and mechanical well cleaning solutions to remove scale, paraffin, asphaltenes, corrosion deposits and other obstructions affecting well performance.</p>

                                        <div className="row ">
                                            <div className="col-md-12 m-b15">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt=""/>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>We combine specialized chemicals with advanced tools to restore production efficiency and prevent future damage.</p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Chemical cleaning</li>
                                                    <li>Paraffin & asphaltene removal</li>
                                                    <li>Scale dissolving agents</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Mechanical scraping</li>
                                                    <li>Preventive treatment programs</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Key Benefits</h4>
                                        <p>Improves flow efficiency, reduces downtime and extends well life.</p>

                                        <div className="row">
                                           
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Restores optimal wellbore performance.</li>
                                                    <li><i className="flaticon-light-bolt"></i>Reduces equipment wear and blockages.</li>
                                                    <li><i className="flaticon-mask"></i>Eco-friendly and safe cleaning solutions.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Chemical Treatments</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        High-efficiency dissolvers for scale, paraffin and asphaltene removal.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Mechanical Cleaning</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Tools and equipment for hard-deposit removal and full wellbore restoration.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="2">
                                                    <Link to="#">Preventive Programs</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        Routine maintenance solutions to reduce downtime and increase well longevity.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer1 />
            </>
        );
    }
}

export default SolutionWellCleaningMaintenance;
